var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLookaheadOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lookahead",
    clipPath: "url(#clip0_12876_182916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M12.0332 3.62012H1.75V5.5H2.75V4.40332H10.6445V7.27441H2.75V6.25H1.75V9H8.81934L10.2578 7.56055L12.0254 9.3291L10.2578 11.0967L8.91113 9.75H1V3.62012H0V0.75H12.0332V3.62012ZM9.55078 9.3291L10.2578 10.0361L10.9648 9.3291L10.2578 8.62207L9.55078 9.3291ZM3.5332 6.49121H9.86133V5.18652H3.5332V6.49121ZM0.783203 2.83789H11.25V1.5332H0.783203V2.83789Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12876_182916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLookaheadOutline);
export default __webpack_public_path__ + "static/media/icon--lookahead-outline.cabbc630bc3b83b101eec88278682337.svg";
export { ForwardRef as ReactComponent };